// import React from "react";
// import "./Average_Rating.css";
// import Rating from "react-rating";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
// import { faStar as fasStar } from "@fortawesome/free-solid-svg-icons";
// import { ProgressBar } from "react-bootstrap";
// import Common_Btn_Yellow from "../../../common-components/common_btn_yellow/Common_Btn_Yellow";

// function Average_Rating({ avg_rating, product }) {
//   const ratings = [
//     { stars: 5, percentage: 90 },
//     { stars: 4, percentage: 60 },
//     { stars: 3, percentage: 40 },
//     { stars: 2, percentage: 30 },
//     { stars: 1, percentage: 0 },
//   ];

//   console.log(avg_rating, "avg_rating avg_rating");

//   return (
//     <section className="Average_Rating">
//       <div className="three_box_div">
//         <div className="write_btn_div">
//           <Common_Btn_Yellow type="submit" text={"Submit Now"} />
//         </div>
//       </div>

//       <div className="heading_holder">
//         <h4>Average Rating</h4>
//         <Rating
//           initialRating={Number(avg_rating?.average_rating)}
//           emptySymbol={<FontAwesomeIcon icon={farStar} color="#880c2a" />}
//           fullSymbol={<FontAwesomeIcon icon={fasStar} color="#880c2a" />}
//           fractions={2}
//           readonly
//         />
//       </div>

//       <div className="rating_breakdown mt-3">
//         {avg_rating?.rating_counts?.map((rating, index) => (
//           <div
//             className="rating_row d-flex align-items-center mb-2"
//             key={index}
//           >
//             <span className="me-2 fw-bold">{rating.name}</span>
//             <ProgressBar
//               now={rating.percentage}
//               style={{ flexGrow: 1, height: "10px" }}
//               variant="success"
//             />
//             <span className="ms-2">{rating.percentage}%</span>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }

// export default Average_Rating;

import React, { useState } from "react";
import "./Average_Rating.css";
import Rating from "react-rating";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
import { faStar as fasStar } from "@fortawesome/free-solid-svg-icons";
import { ProgressBar } from "react-bootstrap";
import Common_Btn_Yellow from "../../../common-components/common_btn_yellow/Common_Btn_Yellow";
import Submit_Your_Review from "../submit_Your_Review/Submit_Your_Review";

function Average_Rating({ avg_rating, product }) {
  const [showReviewModal, setShowReviewModal] = useState(false); 
  return (
    <section className="Average_Rating">
      <div className="rating_card">
        <div className="score_box">
          <p className="score_title">Customer Rating</p>
          <h2 className="score_value">
            {Number(avg_rating?.average_rating || 0).toFixed(1)}
            <span className="score_total">/ 5.0</span>
          </h2>

          <Rating
            className="score_stars"
            initialRating={Number(avg_rating?.average_rating || 0)}
            emptySymbol={<FontAwesomeIcon icon={farStar} color="#f4b400" />}
            fullSymbol={<FontAwesomeIcon icon={fasStar} color="#f4b400" />}
            fractions={2}
            readonly
          />

          <p className="score_count">
            Based on {avg_rating?.total_counts || 0} Reviews
          </p>
        </div>

        <div className="rating_breakdown">
          {avg_rating?.rating_counts?.map((rating, index) => (
            <div className="rating_row" key={index}>
              <span className="star_label">
                {rating.name}
                <FontAwesomeIcon icon={fasStar} className="star_icon" />
              </span>

              <ProgressBar
                now={rating.percentage}
                className="custom_progress"
              />

              <span className="percent_label">
                {Math.round(Number(rating.percentage) || 0)}%
              </span>
            </div>
          ))}
        </div>

        <div className="review_box">
          <h5 className="review_title">Review this product</h5>
          <p className="review_text">
            Share your thoughts with other customers
          </p>
          <Common_Btn_Yellow
            text={"Write a Review"}
            onClick={() => setShowReviewModal(true)}
          />
        </div>
      </div>
      <Submit_Your_Review
        show={showReviewModal}
        onHide={() => setShowReviewModal(false)}
        product={product}
      />
    </section>
  );
}

export default Average_Rating;
